export default __webpack_public_path__ + "static/media/logo-principal.28988436.png";